import { render } from "./cpt-suspension-option.vue?vue&type=template&id=65b34560"
import script from "./cpt-suspension-option.vue?vue&type=script&lang=js"
export * from "./cpt-suspension-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__